import React, { useState } from "react";
import { ChevronDownIcon } from "@heroicons/react/24/outline";
import Loader from "../../../../components/Loader";

const PhoneInput = ({ onGetOtp, isLoading }) => {
    const [phone, setPhone] = useState("");

    const handleChange = (e) => {
        let val = e.target.value.replace(/\D/g, "");
        if (val.startsWith('0')) {
            val = '8' + val.slice(1);
        }
        if (val.length > 15) return;
        setPhone(val);
    };

    const isValid = phone.length >= 8;

    const handleSubmit = () => {
        if (!isValid || isLoading) return;
        onGetOtp(phone);
    };

    return (
        <>
            {isLoading && <Loader />}
            <h2 className="text-2xl font-bold text-gray-900 mb-1">Login/Register</h2>
            <p className="text-md font-bold text-gray-900">Silahkan masukkan nomor telepon Anda</p>
            <p className="text-sm text-gray-500 mb-8">Nomor telepon Anda akan digunakan untuk verifikasi dan masuk ke akun Anda.</p>
            <div className="flex items-center bg-gray-100 rounded-2xl px-4 py-3.5 gap-2 mb-4">
                <div className="flex items-center gap-1 pr-3 border-r border-gray-300 shrink-0">
                    <span className="text-sm font-medium text-gray-700">+62</span>
                </div>
                <input
                    type="tel"
                    inputMode="numeric"
                    pattern="[0-9]*"
                    placeholder="Masukkan Nomor Telepon anda"
                    value={phone}
                    onChange={handleChange}
                    disabled={isLoading}
                    className="flex-1 bg-transparent text-sm text-gray-700 placeholder-gray-400 outline-none border-0"
                />
            </div>
            <p className="text-xs text-gray-500 mb-8">  Dengan melanjutkan, Anda menyetujui untuk menerima SMS dari Ultra Voucher untuk verifikasi nomor telepon.</p>
            <button
                onClick={() => handleSubmit()}
                disabled={!isValid || isLoading}
                className={`w-full py-4 rounded-full font-semibold text-sm transition-all border-0
                    ${isValid
                        ? "bg-[var(--rose-violet)] text-white cursor-pointer"
                        : "bg-gray-100 text-gray-300 cursor-not-allowed"
                    }`}
            >
                Meminta OTP
            </button>
        </>
    );
};

export default PhoneInput;